import { render, staticRenderFns } from "./PrincipalRegister.vue?vue&type=template&id=94b5facc&scoped=true"
import script from "./PrincipalRegister.vue?vue&type=script&lang=js"
export * from "./PrincipalRegister.vue?vue&type=script&lang=js"
import style0 from "./PrincipalRegister.vue?vue&type=style&index=0&id=94b5facc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5facc",
  null
  
)

export default component.exports